import { ReactNode } from 'react';
import { Flex, Switch, Typography } from 'antd';
import { FunctionComponent } from 'react';

interface SwitchElementProps {
	label: string | ReactNode;
	description?: string;
	checked?: boolean;
	controlled?: boolean;
	disabled?: boolean;
	onChange: (value: boolean) => void;
	className?: string;
}

const SwitchElement: FunctionComponent<SwitchElementProps> = ({ label, description, onChange, checked, controlled, disabled, className }) => {
	return (
		<Flex
			align={description ? 'flex-start' : 'center'}
			gap={10}
			className={`mb-1 ${className ?? ''}`}
			style={description ? { opacity: disabled ? 0.45 : 1 } : undefined}>
			<Switch {...(controlled ? { checked } : { defaultChecked: checked })} onChange={onChange} disabled={disabled} />

			{description ? (
				<div>
					<h6 className="mb-0">{label}</h6>
					<p className="text-light mb-0">{description}</p>
				</div>
			) : typeof label === 'string' ? (
				<Typography.Text style={{ color: '#333' }}>{label}</Typography.Text>
			) : (
				label
			)}
		</Flex>
	);
};

export default SwitchElement;
